import * as yup from "yup";

// Define the regionTypeLabel variable
const regionTypeLabel = "Region Name";

export const schema = [
  yup.object({
    name: yup
      .string()
      .required("Please provide the name")
      .max(30, "name cannot exceed 30 characters")
      .matches(/^[A-Za-z\s]+$/, "Please provide a valid name"),
    description: yup
      .string()
      .nullable() // Allow null values (empty string)
      .max(200, "Description must be at most 200 characters"),
    zipcode: yup
      .string()
      .when('$disableZipcode', {
        is: true,
        then: yup.string().nullable(), // Make optional when disabled
        otherwise: yup
          .string()
          .required("PIN Code is required")
          .matches(/^[0-9]+$/, "PIN Code must contain only numbers")
          .length(6, "PIN Code must be exactly 6 digits")
      }),
  }),
];

export const createRegionFormConfig = [
  {
    id: 0,
    name: "Create Region",
    fields: [
      {
        name: "name",
        label: regionTypeLabel, // Now properly defined above
        type: "input",
        mandatory: "true",
      },
      {
        name: "zipcode",
        label: "PIN Code",
        type: "input",
        mandatory: "true"
      },
      {
        name: "description",
        label: "Region Description",
        type: "text_area",
      },
    ],
  },
];